import styled from 'styled-components'

export const Layout = styled.section`
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-start;
`

export const PasswordForm = styled.form`
    min-width: 300px;
    display: flex;
    flex-direction: column;
    gap: 1rem;
`
